import {
  Divider,
  Grid,
  List,
  ListItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import useFetch from "./FetchData/useFetch";
import Header from "../common/Header";
import Footer from "../common/Footer";

const BlogArticle = () => {
  const { getArticleByOgUrl, trendingArticles, articleDetails, getArticle } =
    useFetch();
  const navigate = useNavigate();
  const { ogUrl } = useParams();

  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [progressVisible, setProgressVisible] = useState(false);
  const categories = [
    ...new Set(articleDetails.map((article) => article.category)),
  ].filter((category) => category.trim() !== "");
  const mobileScreen = useMediaQuery(
    "(min-width: 375px) and (max-width:599px)"
  );
  const tabScreen = useMediaQuery("(min-width: 600px) and (max-width:1023px)");
  const laptopScreen = useMediaQuery(
    "(min-width: 1024px) and (max-width: 1240px)"
  );
  const mediumLaptopScreen = useMediaQuery(
    "(min-width: 1241px) and (max-width: 1440px)"
  );
  const largeLaptopScreen = useMediaQuery(
    "(min-width: 1441px) and (max-width: 1663px)"
  );
  const handleBlogNavigate = (category) => {
    navigate(`/article/${category.toLowerCase().replace(/\s+/g, "-")}`);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };
  useEffect(() => {
    getArticle();
    getArticleByOgUrl();
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const fullHeight = document.body.scrollHeight;

      const scrolled = (scrollY / (fullHeight - windowHeight)) * 100;
      setScrollPercentage(scrolled);

      if (scrollY > 110) {
        setProgressVisible(true);
      } else {
        setProgressVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [ogUrl]);
  return (
    <div>
      <Header />
      <Grid sx={{ fontFamily: `"IBM Plex Sans", sans-serif` }}>
        <Grid
          sx={{
            width: "100%",
            height: 400,
            // background: "#1d1a57",
            background: "#262272",
            display: "flex",

            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {mobileScreen ? (
            <Grid
              container
              xs={12}
              sx={{
                display: "flex",

                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {trendingArticles.map((articletitle, index) => (
                <Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      color: "#FFF",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      sx={{
                        width: 275,
                        height: 200,
                        py: 2,
                      }}
                    >
                      <img
                        src={articletitle.featuredUrl}
                        alt="blogimage"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      color: "#FFF",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      px: 2,
                    }}
                  >
                    <Grid
                      sx={{
                        color: "#FFF",
                        width: 350,
                      }}
                    >
                      <Typography
                        variant="h3"
                        sx={{
                          fontWeight: 600,
                          lineHeight: 1.5,
                          fontSize: 30,
                          textAlign: "center",
                        }}
                      >
                        {articletitle.blogTitle}
                      </Typography>
                      <Typography sx={{ fontSize: 14, textAlign: "center" }}>
                        Updated:&nbsp;{formatDate(articletitle.date)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          ) : (
            <></>
          )}
          {!mobileScreen ? (
            <Grid
              container
              md={12}
              sx={{
                display: "flex",
                mx: 5,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid
                item
                md={7}
                sx={{
                  color: "#FFF",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: tabScreen ? "center" : "flex-start",
                }}
              >
                {trendingArticles.map((articletitle, index) => (
                  <Grid
                    sx={{
                      color: "#FFF",
                      width: tabScreen ? 600 : laptopScreen ? 500 : 650,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        lineHeight: 1.5,
                        fontSize: tabScreen ? 28 : laptopScreen ? 30 : "auto",
                        textAlign: tabScreen ? "center" : "left",
                        py: tabScreen ? 5 : "auto",
                      }}
                    >
                      {articletitle.blogTitle}
                    </Typography>
                    {/* <Typography
                        sx={{
                          py: 2,
                          fontSize: tabScreen ? 12 : laptopScreen ? 14 : "auto",
                          textAlign: tabScreen ? "center" : "left",
                        }}
                      >
                        By Tim Soulo, Joshua Hardwick
                      </Typography> */}
                    <Typography
                      sx={{
                        fontSize: tabScreen ? 12 : laptopScreen ? 14 : "auto",
                        textAlign: tabScreen ? "center" : "left",
                      }}
                    >
                      Updated:&nbsp;{formatDate(articletitle.date)}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
              <Grid
                item
                md={5}
                sx={{
                  color: "#FFF",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  py: tabScreen ? 5 : "auto",
                }}
              >
                {trendingArticles.map((articletitle, index) => (
                  <Grid
                    sx={{
                      width: tabScreen
                        ? 350
                        : laptopScreen
                          ? 450
                          : mediumLaptopScreen
                            ? 500
                            : 650,
                      height: tabScreen
                        ? 200
                        : laptopScreen
                          ? 270
                          : mediumLaptopScreen
                            ? 325
                            : 375,
                      background: "#FFF",
                    }}
                  >
                    <img
                      src={articletitle.featuredUrl}
                      alt="blogimage"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
        <Grid
          sx={{
            width: "100%",
            height: 40,
            // background: "#f0f8ff",
            background: "#1d1a57",
            boxShadow: 2,
            display: mobileScreen ? "none" : "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "sticky",
            overflow: "hidden",
            top: 0,
            zIndex: 3,
          }}
        >
          <List
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#FFF",
              whiteSpace: "nowrap",
              cursor: "pointer",
              fontSize: laptopScreen ? 14 : "auto",
              textTransform: "capitalize",
            }}
          >
            {categories.map((category, index) => (
              <ListItem
                key={index}
                onClick={() => handleBlogNavigate(category)}
              >
                {category}
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid
          container
          md={12}
          sm={12}
          sx={{ px: 7, py: 5, display: "flex", height: "auto" }}
        >
          <Grid
            item
            md={3}
            sm={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Grid
              sx={{ width: "100%", position: "sticky", top: 130, zIndex: 2 }}
            >
              <Typography sx={{ fontSize: laptopScreen ? 16 : 22 }}>
                Table of Contents
              </Typography>
              <List sx={{ cursor: "pointer" }}>
                {trendingArticles.map((tablecontent, index) => (
                  <ListItem
                    sx={{
                      color: "#8f8e98",
                      fontSize: laptopScreen ? 14 : 16,

                      px: 1,
                      "&:hover": {
                        background: "#f0f8ff",
                        px: 1,
                      },
                    }}
                  >
                    {/* <FontAwesomeIcon
                        icon={faCaretRight}
                        style={{ fontSize: 15 }}
                      />
                      &nbsp;&nbsp;  */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: tablecontent.tableOfContent,
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <Grid>
              {trendingArticles.map((blogData, index) => (
                <div
                  dangerouslySetInnerHTML={{ __html: blogData.blogContent }}
                />
              ))}
            </Grid>
          </Grid>
          <Grid
            item
            md={3}
            sm={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              "@media (min-width: 960px)": {
                // Apply styles only for desktop (md and up)
                alignItems: "center", // Center content on desktop
              },
            }}
          >
            <Grid
              sx={{
                width: 250,
                position: "sticky",
                top: 130,
                zIndex: 2,
                justifyContent: "center",
              }}
            >
              {/* <img
                                style={{ width: '100%' }}
                                src={Image1}
                                alt="Sticky Image"
                            /> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Footer variant="light" />
    </div>
  );
};

export default BlogArticle;
